__turbopack_context__.v({
  "badge": "RadioToggleButton-module__w2pAya__badge",
  "badgeStyle_DEFAULT": "RadioToggleButton-module__w2pAya__badgeStyle_DEFAULT",
  "badgeStyle_STYLE1": "RadioToggleButton-module__w2pAya__badgeStyle_STYLE1",
  "checked": "RadioToggleButton-module__w2pAya__checked",
  "container": "RadioToggleButton-module__w2pAya__container",
  "subtext": "RadioToggleButton-module__w2pAya__subtext",
  "ticketDisplay": "RadioToggleButton-module__w2pAya__ticketDisplay",
});
